/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DagRunDto = {
    dagId?: string;
    endDate?: number;
    executionDate?: number;
    externalTrigger?: boolean;
    note?: string;
    runType?: DagRunDto.runType;
    startDate?: number;
    state?: DagRunDto.state;
};

export namespace DagRunDto {

    export enum runType {
        MANUAL = 'MANUAL',
        SCHEDULED = 'SCHEDULED',
        BACKFILL = 'BACKFILL',
        TRIGGERED = 'TRIGGERED',
        UNKNOWN = 'UNKNOWN',
    }

    export enum state {
        QUEUED = 'QUEUED',
        RUNNING = 'RUNNING',
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
        SKIPPED = 'SKIPPED',
        CANCELLED = 'CANCELLED',
        TIMED_OUT = 'TIMED_OUT',
        BLOCKED = 'BLOCKED',
        UNKNOWN = 'UNKNOWN',
    }


}
